/**
 * Number formatter.
 */
export function formatNumber(
    options: Intl.NumberFormatOptions,
    locale?: string
) {
    const formatter = new Intl.NumberFormat(locale, options)

    return (value: number) => formatter.format(value)
}

/**
 * Formatter used for imports.
 */
export function importsValueFomatter(locale?: string) {
    const formatter = formatNumber(
        {
            compactDisplay: 'short',
            notation: 'compact',
            style: 'currency',
            currency: 'USD'
        },
        locale
    )

    return (value: number) => formatter(value * 1000)
}

/**
 * Formatter used for absolute values of prevalence.
 */
export function prevalenceAbsoluteFormatter(locale?: string) {
    return formatNumber(
        {
            compactDisplay: 'short',
            notation: 'compact'
        },
        locale
    )
}

/**
 * Default value formatter.
 */
export function defaultFormatter(locale?: string) {
    return formatNumber(
        {
            maximumFractionDigits: 1
        },
        locale
    )
}
